import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, DevNotice } from "@wsui/base";
import DefaultTextModule from "./DefaultTextModule.mjs";
import ExpandableTextModule from "./ExpandableTextModule.mjs";
function defaultComponentMapping(_ref) {
  let {
    expandable
  } = _ref;
  if (expandable) return ExpandableTextModule;
  return DefaultTextModule;
}
function TextModuleController(props) {
  props = useThemeProps({
    props,
    name: "MunicipioTextModuleController"
  });
  let {
    componentMapping,
    ...restProps
  } = props;
  const Component = typeof componentMapping === "function" ? componentMapping(restProps, defaultComponentMapping) : defaultComponentMapping(restProps);
  if (!Component) {
    return /* @__PURE__ */jsx(DevNotice, {
      children: `Text module could not be mapped to a component`
    });
  }
  return /* @__PURE__ */jsx(Component, {
    ...restProps
  });
}
export { TextModuleController as default };